<template>

	<div id="wrapper" 
       :class="{ 'app-menu-open':appMenuStatus }">

    <AppMenu ref="appMenu"/>

    <Header/>

    <Loading :status="isLoading" 
             :opacity="1"
             class="global-loading"
             :linear="isLoading=='linear'"/>

    <video-background>

      <!-- default dashbord -->
      <Dashboard v-if="!hasOpenApps"/>

      <iframe v-for="(app,i) in openApps"
              :key="i"
              class="zwan-space"
              :src="app.urlWithToken"
              v-show="app.isVisible"
              @load="onIframeLoad"
              allow="clipboard-write"
      ></iframe>

    </video-background>

    <Crisp v-if="hasChat"/>

	</div>
  
</template>

<style lang="scss">
  .pointer { cursor: pointer !important; }

  iframe.zwan-space {
    border:  0;
    width:  100%;
    height:  calc( 100vh - 50px );
  }

  #wrapper {

    &.app-menu-open {
      iframe.zwan-space {
        height:  calc( 100vh - 220px );
        transition-delay: .7s;
      }    
    }

  }

  html {
    overflow: hidden;
  }
</style>

<script>
import SETTINGS from '@/settings'

import utility from '@/mixins/utility'

import AppMenu from '@/components/AppMenu'
import Crisp from '@/components/Crisp'
import Dashboard from '@/components/Dashboard2'
import Header from '@/components/Header'
import Loading from '@/components/Loading'
import VideoBackground from '@/components/VideoBg'

import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'Home',

  mixins: [ utility ],

  components:
  {
    AppMenu,
    Crisp,
    Dashboard,
    Header,
    Loading,
    VideoBackground,
  },

  data: () => ({
    
  }),

  computed:
  {
    ...mapGetters({
      isLoading: 'ui/isLoading',
      items: 'menu/apps',
      openApps: 'menu/openApps',
      hasOpenApps: 'menu/hasOpenApps',
      appMenuStatus: 'menu/appMenuStatus'
    }),

    hasChat()
    {
      return SETTINGS.CRISP.websiteId
    }
  },

  methods:
  {
    ...mapActions({
      fetchMenu: 'menu/fetch',
      toggleAppMenu: 'menu/toggleAppMenu'
    }),

    ...mapMutations({
      setLoading: 'ui/setLoading'
    }),

    onIframeLoad()
    {
      this.setLoading(false)
    },

    onKeyPress(e)
    {
      const keyCode = e.keyCode

      switch(keyCode)
      {
        // escape.
        case 27: this.toggleAppMenu(); break;
      }
    }

  },

  mounted()
  {
    this.fetchMenu()

    window.addEventListener('keydown', this.onKeyPress)
  },

  watch: {}
};
</script>
